import throttle from 'lodash/throttle';

window.customElements.define('page-bar', class extends HTMLElement {
  constructor() {
    super();
    this.scrollPos = 0;
    this.stickThreshold = 20;
    this.handleScroll();
    // this.brand = this.querySelector('.page-header__brand');
    window.addEventListener('scroll', throttle(() => {
      this.handleScroll();
    }, 100)
      .bind(this));
  }

  stick() {
    this.classList.add('page-header__bar_sticky');
  }

  unstick() {
    this.classList.remove('page-header__bar_sticky');
  }

  handleScroll() {
    const mainnavContentIsActive = this.querySelector('.mainnav-content.is-active');

    if (mainnavContentIsActive) {
      // If mainnav__content.is-active exists inside page-bar
      const mainnavCardsBottom = this.querySelector('.mainnav__cards').getBoundingClientRect().bottom;
      this.stickThreshold = mainnavCardsBottom + 50;
    } else {
      // Use the default stickThreshold value
      this.stickThreshold = 20;
    }

    if (window.scrollY >= this.stickThreshold) {
      this.stick();
    } else {
      this.unstick();
    }
  }
});
